module.exports = __webpack_public_path__ + "static/media/SN.e41e52f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SN.svg
// module id = 362
// module chunks = 0